/** Skeleton placeholder for the Home workbench (greeting + 3 category tiles).
 *  Shown while auth initializes so the shell stays put and only the content
 *  area animates in — no full-screen loader. */
const TileSkeleton = () => (
  <div className="bg-white dark:bg-gray-800/80 rounded-2xl shadow-sm dark:shadow-none dark:ring-1 dark:ring-gray-700/50 overflow-hidden">
    {/* Header */}
    <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700/50 flex items-center gap-2.5">
      <div className="h-10 w-10 rounded-xl bg-gray-200 dark:bg-gray-700 animate-pulse" />
      <div className="h-4 w-28 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
      <div className="ml-auto h-3 w-4 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
    </div>
    {/* Tool rows */}
    <div className="p-2.5 space-y-1">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-3 py-2.5">
          <div className="h-5 w-5 rounded bg-gray-200 dark:bg-gray-700 animate-pulse shrink-0" />
          <div className="h-4 w-32 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
        </div>
      ))}
    </div>
  </div>
);

export const HomeSkeleton = ({ message }: { message?: string }) => (
  <div className="space-y-6">
    {/* Status line — tells the user exactly what auth/init step is running. */}
    {message && (
      <div className="text-sm text-gray-500 dark:text-gray-400">
        <span>{message}</span>
      </div>
    )}

    {/* Greeting placeholder */}
    <div className="flex items-start justify-between gap-4">
      <div className="space-y-2">
        <div className="h-7 w-64 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
        <div className="h-4 w-40 rounded bg-gray-200 dark:bg-gray-700 animate-pulse" />
      </div>
    </div>

    {/* Category tiles */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {Array.from({ length: 3 }).map((_, i) => (
        <TileSkeleton key={i} />
      ))}
    </div>
  </div>
);

export default HomeSkeleton;
